import { useBoundStore } from '../store'

export const useUser = () =>
  useBoundStore((state) => ({
    user: state.user,
    role: state.getUserRole(),
    subscription: state.getUserSubscription(),
    isProfileCompleted: state.isProfileCompleted(),
    brand: state.user && Array.isArray(state.user.brand) && state.user.brand.length > 0 ? state.user.brand : null,
  }))
